import React from 'react';

export default function Hero() {
  return (
    <section className="min-h-[92vh] grid grid-cols-1 lg:grid-cols-2 items-center px-[8%] lg:px-[12%] pt-20 pb-16 lg:pb-15 gap-12 lg:gap-15 relative overflow-hidden">
      {/* Background elements */}
      <div className="absolute inset-0 bg-hero-pattern pointer-events-none"></div>
      <div className="hidden lg:block absolute right-[-10%] top-[-10%] bottom-[-10%] w-[55%] bg-hero-radial pointer-events-none"></div>

      <div className="relative z-10">
        <div className="inline-flex items-center gap-2 bg-gold/15 border border-gold/40 text-gold py-1.5 px-3.5 rounded-sm font-condensed text-[13px] font-bold tracking-[0.12em] uppercase mb-6">
          <span className="text-[8px] animate-blink">●</span> Serving Salisbury & Eastern Shore
        </div>
        
        <h1 className="font-condensed font-black text-[clamp(48px,10vw,88px)] lg:text-[clamp(52px,6vw,88px)] leading-[0.95] uppercase tracking-tight mb-7 text-white">
          <span className="bg-black px-4 lg:px-6 py-2 inline-block mb-3 shadow-[8px_8px_0px_0px_rgba(232,168,32,1)]">We Haul.</span>
          <br/>
          <em className="text-gold not-italic block mt-2">You Relax.</em>
        </h1>
        
        <p className="text-lg leading-relaxed text-text-muted max-w-md mb-10 font-medium">
          Eastern Shore Junk Removal clears out furniture, appliances, yard debris, and clutter fast. We do all the heavy lifting — you just point and we haul it away.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center">
          <a href="tel:4433592010" className="bg-gold text-dark font-black py-4 px-8 rounded font-condensed text-[18px] tracking-wider uppercase no-underline inline-flex items-center gap-2 transition-all shadow-[0_4px_20px_rgba(232,168,32,0.4)]">
            📞 Get Free Quote
          </a>
          <a href="mailto:shorejunk1111@gmail.com" className="bg-black text-white py-[15px] px-7 rounded border-2 border-black font-condensed font-bold text-[17px] tracking-wide uppercase no-underline inline-flex items-center gap-2 transition-all">
            ✉ Send Email
          </a>
        </div>
        
        <div className="flex flex-col sm:flex-row gap-4 sm:gap-7 mt-11 text-[14px] text-text-muted font-semibold">
          {['Locally Owned', 'Same-Day Service', 'Upfront Pricing', '5-Star Rated'].map(text => (
            <div key={text} className="flex items-center gap-2">
              <div className="w-1.5 h-1.5 bg-gold rounded-full shrink-0"></div>
              {text}
            </div>
          ))}
        </div>
      </div>

      <div className="bg-dark-2 border border-dark-4 rounded-lg p-10 relative z-10 shadow-[0_24px_80px_rgba(0,0,0,0.6)]">
        <div className="font-condensed text-[12px] font-bold tracking-[0.2em] uppercase text-gold mb-5">How It Works</div>
        <div className="font-condensed text-[32px] font-black uppercase leading-[1.1] mb-7 text-white">Gone in<br/>4 Easy Steps</div>
        
        <ul className="list-none flex flex-col gap-5 mb-8">
          {[
            { num: '1', title: 'Call or Text Us', desc: 'Get a free no-obligation quote in minutes.' },
            { num: '2', title: 'Pick a Time', desc: 'We work around your schedule, even same-day.' },
            { num: '3', title: 'We Arrive & Haul', desc: 'Our crew does all the heavy lifting for you.' },
            { num: '4', title: 'Enjoy the Space', desc: 'Clean, cleared, and stress-free.' }
          ].map(step => (
            <li key={step.num} className="flex items-start gap-4">
              <div className="w-8 h-8 shrink-0 bg-gold text-dark rounded-full font-condensed font-black text-[16px] flex items-center justify-center">
                {step.num}
              </div>
              <div className="text-[15px] text-text-muted pt-0.5 leading-snug font-medium">
                <strong className="text-white block font-bold mb-0.5">{step.title}</strong>
                {step.desc}
              </div>
            </li>
          ))}
        </ul>
        
        <a href="tel:4433592010" className="block w-full text-center bg-gold text-dark p-4 rounded font-condensed font-black text-2xl tracking-wide uppercase no-underline transition-colors shadow-[0_4px_20px_rgba(232,168,32,0.3)]">
          Call 443-359-2010
          <small className="block text-[13px] font-bold tracking-[0.1em] mt-0.5 opacity-80">FREE QUOTE • NO OBLIGATION</small>
        </a>
      </div>
    </section>
  );
}